import {
  endOfMonth,
  endOfToday,
  endOfYear,
  endOfYesterday,
  isFirstDayOfMonth,
  startOfDay,
  startOfMonth,
  startOfYear,
  subDays,
  subMonths,
  subYears,
} from 'date-fns'

const isFirstDayOfYear = () => new Date().getMonth() === 0 && new Date().getDate() === 1

export const oneWeek = (): [Date, Date] => [startOfDay(subDays(new Date(), 7)), endOfYesterday()]
export const twoWeeks = (): [Date, Date] => [startOfDay(subDays(new Date(), 14)), endOfYesterday()]
export const oneMonth = (): [Date, Date] => [startOfDay(subMonths(new Date(), 1)), endOfYesterday()]
export const oneYear = (): [Date, Date] => [startOfDay(subYears(new Date(), 1)), endOfYesterday()]
export const last30Days = (): [Date, Date] => [
  startOfDay(subDays(new Date(), 30)),
  endOfYesterday(),
]
export const last30DaysIncludingToday = (): [Date, Date] => [
  startOfDay(subDays(new Date(), 30)),
  endOfToday(),
]
export const thisMonth = (): [Date, Date] => [
  startOfMonth(new Date()),
  isFirstDayOfMonth(new Date()) ? new Date() : endOfYesterday(),
]
export const lastMonth = (): [Date, Date] => [
  startOfMonth(subMonths(new Date(), 1)),
  endOfMonth(subMonths(new Date(), 1)),
]
export const lastYear = (): [Date, Date] => [
  startOfYear(subYears(new Date(), 1)),
  endOfYear(subYears(new Date(), 1)),
]
export const currentYear = (): [Date, Date] => [
  startOfYear(new Date()),
  isFirstDayOfYear() ? new Date() : endOfYesterday(),
]
export const defaultDateRange = oneWeek
